<template>
  <div class="modal-fullscreen">
    <div class="modal">
      <div class="pull-right">
        <div class="btn-close" @click="close"></div>
      </div>
      <h1>Parameter eingeben</h1>
      <form>
        <h3>Adresse</h3>
        <div class="input-group">
          <input
            type="search"
            placeholder="Adresse"
            style="font-size: 28px"
            v-model="address"
          />
        </div>
        <h3>Start</h3>
        <div class="input-group">
          <input type="date" style="font-size: 18px" v-model="startDate" />
        </div>
        <h3>Ende</h3>
        <div class="input-group">
          <input type="date" style="font-size: 18px" v-model="endDate" />
        </div>
      </form>
      <div class="footer">
        <button @click="goToLoadProfile">Erstellen</button>
      </div>
    </div>
    <div class="loading" v-show="loading">
      <div class="progress-icon"></div>
    </div>
  </div>
</template>

<script>
import AmplifyStore from '../store/store';
export default {
  name: 'SlpProfile',
  data() {
    return {
      loading: false,
      name: null,
      startDate: null,
      endDate: null,
      address: null,
      state: { name: null, shortName: null },
      statesFilter: null,
      selectStateVisible: false,
      slpProfileMetaData: null,
      apiEndPoint: 'https://beta-weather.api.codelos.io',
    };
  },
  computed: {
    user() {
      return AmplifyStore.state.user;
    },
  },
  methods: {
    close() {
      this.$emit('close', null);
    },
    getImgUrl: function (img) {
      if (img) {
        var images = require.context('../assets/img/', false, /\.png$/);
        return images(img);
      } else return '';
    },
    returnWeatherProfile: function () {
      this.weatherProfileMetaData = {
        name: this.name,
        address: this.address,
        start: this.startDate,
        end: this.endDate,
      };
      this.$emit('close', this.weatherProfileMetaData);
    },
    resetValues: function () {
      this.weatherProfileMetaData = null;
      this.startDate = null;
      (this.endDate = null), (this.address = null);
    },
    goToLoadProfile: function () {
      // loading screen
      this.loading = true;

      // get api end point
      var url = this.apiEndPoint;

      // add function name
      url += '/temperature-history';

      // API headers
      var myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken + ''
      );

      // API params
      url += '?address=' + this.address;
      url += '&start=' + this.startDate;
      url += '&end=' + this.endDate;

      fetch(url, {
        headers: myHeaders,
      })
        .then((response) => response.clone().json())
        .then((data) => {
          this.loading = false;
          this.resetValues();
          this.$emit('close', data);
        });
    },
    select(p) {
      this.slpProfileTypes.forEach((p) => {
        p.selected = false;
      });
      p.selected = true;
      this.selectedSLP = p.id;
    },
    hideSelectState: function () {
      this.statesFilter = this.state.name;
      this.selectStateVisible = false;
    },
    showSelectState: function () {
      this.selectStateVisible = true;
    },
    toggleSelectState: function () {
      this.selectStateVisible = !this.selectStateVisible;
    },
    setState: function (state) {
      this.state = state;
      this.hideSelectState();
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');

          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-fullscreen {
  padding: 20px;
  background: #ffffff;
  display: block;
  width: 100%;
  height: 900px;
  text-align: center;
  margin-left: -14px;
  top: 0;
}

.modal {
  padding: 25px 40px 40px 43px;
  width: 92.5%;
  overflow: auto;
  display: unset;
  z-index: 1;
}

.modal > h1 {
  padding-top: 60px;
  color: #313745;
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.12px;
  line-height: 41px;
  text-align: center;
  display: block;
  width: 860px;
  margin: 0 auto 40px;
  border: 0;
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  position: relative;
  z-index: 1;
  -webkit-font-smoothing: antialiased;
  text-transform: none;
  margin-bottom: 20px;
  font-size: 38px;
  padding-bottom: 6px;
}

.modal > h2 {
  color: #313745;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.16px;
  line-height: 19px;
  padding-bottom: 55px;
}

.group-wrapper {
  overflow: auto;
}

.modal > form {
  margin: 0 20%;
}

.modal > form > h3 {
  color: #22252b;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 16px;
  text-align: left;
  margin-top: 35px;
}

.modal > h4 {
  color: rgba(85, 93, 109, 0.4);
  font-family: 'Open Sans', open-sans, sans-serif;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding-bottom: 55px;
}

input {
  float: none;
  text-align: center;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding: 15px 20px 15px 20px;
  width: 290px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 22px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 52px;
  width: 100%;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #7e8890;
  color: #22252b;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0.23px;
  line-height: 16px;
  padding: 15px 20px 15px 20px;
  text-align: left;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 400px;
  width: 500px;
  overflow: hidden;
}

::placeholder {
  color: #e3e3e3;
  opacity: 1;
}

button.default {
  color: #464d5d;
  background: #fff;
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

.input-group > button {
  margin: 40px auto 0;
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  position: relative;
  z-index: 2;
}

.pull-left {
  float: left;
  z-index: 2;
  height: 30px;
  position: fixed;
}

.modal .btn-back {
  width: 23px;
  cursor: pointer;
}

.item {
  height: 175px;
}

.group-wrapper .item {
  height: 175px;
}

.group-wrapper {
  max-width: 960px;
  margin: 0 auto 0px;
  text-align: center;
  margin-top: 5px;
  overflow: auto;
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
}

.group-wrapper .item-wrapper:hover .img-wrapper {
  filter: none;
}

.group-wrapper .item-wrapper.active .img-wrapper {
  filter: none;
}

.group-wrapper .item-wrapper.active {
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.group-wrapper .item-wrapper:hover {
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.group-wrapper .item-wrapper .img-wrapper {
  filter: grayscale(82%) hue-rotate(246deg) opacity(30%);
}

.group-wrapper .item-wrapper {
  display: inline-block;
  width: 212px;
  height: 230px;
  margin: 10px;
  opacity: 1;
  cursor: pointer;
  text-align: -webkit-match-parent;
  box-shadow: none;
  overflow: hidden;
}

.group-wrapper .img-wrapper {
  width: 100%;
  height: 130px;
}

.group-wrapper input {
  display: initial;
}

.group-wrapper .logo {
  position: absolute;
  width: 43%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  float: none;
  background-color: #fff;
  padding: 0 6px 0 6px;
}

.group-wrapper .item-wrapper h2 {
  color: #434c5e;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.16px;
  line-height: 19px;
}

.footer {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
  height: 100px;
  margin-bottom: 80px;
}

.footer > button {
  display: block;
  width: 180px;
  height: 44px;
  margin: 0 auto 80px;
  background: #fb3467;
  border: 0;
  border-radius: 100px;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  -webkit-transition: background 0.2s ease;
  -o-transition: background 0.2s ease;
  transition: background 0.2s ease;
  cursor: pointer;
}

.footer > button.disabled {
  background-color: rgba(224, 0, 90, 0.3);
  cursor: unset;
}

.group-wrapper .item-wrapper .description {
  font-family: 'SF UI Text', -apple-system, system-ui, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 12px;
  line-height: 19px;
  text-align: center;
  text-transform: none;
  color: #7b8496;
  -webkit-font-smoothing: antialiased;
  max-width: 100%;
  margin: 0px 13px 0px 13px;
  opacity: 0;
  transform: translateY(15px);
  transition: 0.2s ease;
}

.group-wrapper .item-wrapper:hover .description {
  opacity: 1;
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.group-wrapper .item-wrapper.active .description {
  opacity: 1;
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.toggle-list-wrapper {
  width: 100%;
  left: 0px;
  max-width: unset;
  padding-top: 10px;
  top: -35px;
}

.toggle-list-wrapper .item {
  height: 30px;
}

.toggle-list-wrapper .item .label {
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 8px;
  font-size: 14px;
}

input {
  cursor: text;
}

.modal-fullscreen .loading {
  width: 100%;
  height: 100%;
  background-color: #ffff;
  position: fixed;
  top: 0;
  z-index: 3;
}

.progress-icon {
  position: fixed;
  left: 50%;
  transform: translate(-50%);
  top: 250px;
  width: 70px;
  height: 70px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
